module.exports = __webpack_public_path__ + "img/c-07.aa35ea74.jpg";